import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.laboratory'),
    id: 'laboratory',
    sidebar: [
        {
            id: 'countries',
            label: i18n.t('configuration.sections.calendar'),
            icon: 'fal fa-calendar-alt',
            routeName: 'ParametersCalendar',
            hasChildren: false
        },
        {
            id: 'provinces',
            label: i18n.tc('configuration.sections.identity'),
            icon: 'fal fa-palette',
            routeName: 'ParametersIdentity',
            hasChildren: false
        }
    ]
}
